export default function FormatDate(date) {
  let formattedDate = new Date(date).toJSON().slice(0, 10);
  const chunks = formattedDate.split('-');
  formattedDate = `${chunks[1]}/${chunks[2]}/${chunks[0]}`;
  return formattedDate;
}
